let contentGroup: string | null | undefined;

/** undefined = legacy/unloaded, null = explicitly central, string = selected group. */
export function setContentGroup(groupId: string | null | undefined): void { contentGroup = groupId; }
export function contentGroupHeaders(): Record<string, string> {
  return typeof contentGroup === 'string' ? { 'x-content-group': contentGroup } : {};
}
